import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

import {
  GET_VOUCHER_IMPORT_TEMPLATES_FAILURE,
  GET_VOUCHER_IMPORT_TEMPLATES_REQUEST,
  GET_VOUCHER_IMPORT_TEMPLATES_SUCCESS,
  GET_VOUCHER_IMPORT_TEMPLATE_FAILURE,
  GET_VOUCHER_IMPORT_TEMPLATE_REQUEST,
  GET_VOUCHER_IMPORT_TEMPLATE_SUCCESS,
  POST_VOUCHER_IMPORT_TEMPLATE_DRYRUN_FAILURE,
  POST_VOUCHER_IMPORT_TEMPLATE_DRYRUN_REQUEST,
  POST_VOUCHER_IMPORT_TEMPLATE_DRYRUN_SUCCESS,
  POST_VOUCHER_IMPORT_TEMPLATE_FAILURE,
  POST_VOUCHER_IMPORT_TEMPLATE_REQUEST,
  POST_VOUCHER_IMPORT_TEMPLATE_SUBMIT_FAILURE,
  POST_VOUCHER_IMPORT_TEMPLATE_SUBMIT_REQUEST,
  POST_VOUCHER_IMPORT_TEMPLATE_SUBMIT_SUCCESS,
  POST_VOUCHER_IMPORT_TEMPLATE_SUCCESS,
  PUT_VOUCHER_IMPORT_TEMPLATE_FAILURE,
  PUT_VOUCHER_IMPORT_TEMPLATE_REQUEST,
  PUT_VOUCHER_IMPORT_TEMPLATE_SUCCESS,
} from './importVoucherFiles.types';

export const getVoucherImportTemplates = () => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_VOUCHER_IMPORT_TEMPLATES_REQUEST, GET_VOUCHER_IMPORT_TEMPLATES_SUCCESS, GET_VOUCHER_IMPORT_TEMPLATES_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/Vouchers',
    method: 'GET',
  },
});

export const getVoucherImportTemplate = templateId => ({
  [CALL_INTAKE_V2_API]: {
    types: [GET_VOUCHER_IMPORT_TEMPLATE_REQUEST, GET_VOUCHER_IMPORT_TEMPLATE_SUCCESS, GET_VOUCHER_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/Vouchers/${templateId}`,
    method: 'GET',
  },
});

export const postVoucherImportTemplate = template => ({
  [CALL_INTAKE_V2_API]: {
    types: [POST_VOUCHER_IMPORT_TEMPLATE_REQUEST, POST_VOUCHER_IMPORT_TEMPLATE_SUCCESS, POST_VOUCHER_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: 'api/ImportTool/Vouchers',
    method: 'POST',
    payload: template,
  },
});

export const putVoucherImportTemplate = (templateId, template) => ({
  [CALL_INTAKE_V2_API]: {
    types: [PUT_VOUCHER_IMPORT_TEMPLATE_REQUEST, PUT_VOUCHER_IMPORT_TEMPLATE_SUCCESS, PUT_VOUCHER_IMPORT_TEMPLATE_FAILURE],
    authenticated: true,
    endpoint: `api/ImportTool/Vouchers/${templateId}`,
    method: 'PUT',
    payload: template,
  },
});

export const uploadVoucherImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VOUCHER_IMPORT_TEMPLATE_DRYRUN_REQUEST, POST_VOUCHER_IMPORT_TEMPLATE_DRYRUN_SUCCESS, POST_VOUCHER_IMPORT_TEMPLATE_DRYRUN_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/Vouchers/${templateId}/DryRun`,
      method: 'POST',
      payload,
    },
  };
};

export const submitVoucherImportTemplateFile = (templateId, file) => {
  const payload = new FormData();
  payload.append('file', file, file.name);

  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_VOUCHER_IMPORT_TEMPLATE_SUBMIT_REQUEST, POST_VOUCHER_IMPORT_TEMPLATE_SUBMIT_SUCCESS, POST_VOUCHER_IMPORT_TEMPLATE_SUBMIT_FAILURE],
      authenticated: true,
      endpoint: `api/ImportTool/Vouchers/${templateId}/Submit`,
      method: 'POST',
      payload,
    },
  };
};